import { Component, Prop, h } from '@stencil/core';

/**
 * Group of radio buttons rendered from a string array, with an optional heading.
 * Manages mutual exclusion automatically — selecting one option deselects all others.
 * Used in forms and pricing sections where the user picks one option from a set.
 *
 * @example
 *   <me-radio-group name="plan" options='["Starter", "Professional", "Enterprise"]'></me-radio-group>
 */
@Component({
  tag: 'me-radio-group',
  styleUrl: 'index.scss',
  shadow: false,
})
export class MeRadioGroup {
  @Prop() name: string;
  @Prop() options!: string[];
  @Prop({ mutable: true, reflect: true }) value?: string;
  @Prop() heading?: string;

  render() {
    return (
      <div class="radio-group">
        {this.heading && <div class="radio-group__heading">{this.heading}</div>}
        <div class="radio-group__items">
          {this.options.map(label => (
            <div class="radio-group__item" key={label}>
              <me-radio name={this.name} label={label} checked={this.value === label} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
